<div class="market_analysis">
    <div class="col-md-8">
        <div class="card">
            <div class="card-header ma-title">
                <h4 class="mb-0 text-uppercase">Market Analysis</h4>
            </div>
            <div class="card-body">
                <div *ngIf="data">
                    <div class="table-responsive" *ngFor="let eItem of data?.events;trackBy:trackByIndex;">

                        <div class="card-header inner-header">
                            <h4 class="mb-0 text-uppercase">
                                <a href="javascript:void(0);" routerLink="/event/detail/{{eItem.event_id}}">
                                    {{eItem.event_name}}
                                    <a href="javascript:void(0);" type="button" class="btn-sm btn-back">
                                        <i class="fa fa-angle-double-right"></i>
                                    </a>
                                </a>
                            </h4>
                        </div>
                        <!-- {{eItem?.data | json}} -->
                        <table id="account-datatable" class="table table-striped table-bordered" *ngFor="let mItem of eItem?.data;trackBy:trackByIndex;">
                            <thead>
                                <tr>
                                    <th colspan="2">{{mItem?.market_type_id.replace('_',' ')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of mItem?.market_data;trackBy:trackByIndex;">
                                    <td>{{item?.market_type_id == "FANCY" ? item?.fancy_name : item?.market_type_id == "BOOK_MAKER" ? item?.bookmaker_runner_name : item?.runner_name }}</td>
                                    <td [ngClass]="{'text-green' : item?.expose > 0, 'text-red' : item?.expose < 0}"> {{item?.expose}} </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-responsive no-data" *ngIf="data?.events?.length == 0">
                        <h3>There are currently no followed multi markets.</h3>
                        <p>Please add some markets from events.</p>
                    </div>
                </div>
                <app-loader class="no-overlay" *ngIf="!data"></app-loader>
            </div>
        </div>
    </div>
    <!-- <div class="col-md-4 px-0 rightBar">

    </div> -->
</div>

